import React from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet, useLocation } from "react-router-dom";

const PrivateRoutes = () => {
  const { data } = useSelector((state) => state?.authUser);
  const user_info = data?.data;
  const OrgId = user_info?.user_id;
  const location = useLocation();

  if (!OrgId) {
    return <Navigate to="/sign-in" state={{ from: location }} replace />;
  }

  return <Outlet />;
};

export default PrivateRoutes;
